import { createAction, createSlice } from '@reduxjs/toolkit';
import { AccountWithdrawalDataRecord, CoreMsgTypes } from '@tassat/fred-definitions';

export interface AccountWithdrawalDataState {
    [firmId: string]: {
        [withdrawalDataId: string]: AccountWithdrawalDataRecord;
    };
}

const initialState: AccountWithdrawalDataState = {};

const initialLoadAction = createAction<{ accountsWithdrawalData: AccountWithdrawalDataState }>('InitialLoad');
const accountWithdrawalDataRecordAction = createAction<AccountWithdrawalDataRecord>(CoreMsgTypes.AccountWithdrawalDataRecord);

const accountWithdrawalDataSlice = createSlice({
    name: 'accountWithdrawalData',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(initialLoadAction, (_state, action) => {
                return action.payload.accountsWithdrawalData;
            })
            .addCase(accountWithdrawalDataRecordAction, (state, action) => {
                const { FirmId, AccountWithdrawalDataId } = action.payload;
                if (!state[FirmId]) state[FirmId] = {};
                state[FirmId][AccountWithdrawalDataId] = action.payload;
            });
    }
});

export default accountWithdrawalDataSlice.reducer;